import { apiAbortManager } from '@/lib/api-abort-manager';
export default function apiAbort({ to, from, next }) {
    const toName = to.name;
    const fromName = from.name;
    // 같은 페이지에서 replace 이용해서 조회하는 경우에 abort 되는 것을 막기 위해 같은 컴포넌트면 abort하지 않는다는 룰 추가
    if (toName === fromName) {
        return next();
    }
    apiAbortManager.abortAll();
    return next();
}
